module.exports = __webpack_public_path__ + "img/slide06.7539aaa2.jpg";